<template>
  <svg
    width="31"
    height="16"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 31 16"
  >
    <g
      stroke="#FFF"
      stroke-width="1.35"
      fill="none"
      fill-rule="evenodd"
    >
      <path d="M30.251 7.75c0-.112-6.548-6.75-14.625-6.75S1.081 7.67 1.001 7.75C.89 7.862 7.55 14.5 15.626 14.5s14.625-6.638 14.625-6.75z"/>
      <path d="M21.176 6.625a5.4 5.4 0 1 0-10.8 0 5.4 5.4 0 0 0 10.8 0z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'EyeIcon'
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/icons/EyeIcon.vue